import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset, kuiperClassNames } from '@opallabs/kuiper'
import { TwitterStreamFooter } from '../../../sharedDisplays/footers/TwitterStreamFooter'
import { TwitterStreamHeader } from '../../../sharedDisplays/headers/TwitterStreamHeader'
import { assetStyles } from '../../styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content: string
  display: string
  gif?: AssetReference
  index: number
  isAccountPremium?: boolean
  isPresenting: boolean
  isSnapshot: boolean
  isThreaded: boolean
  modulesLength?: number
  onContentChange: (val: string) => void
  onExpandAsset: (assetId: number) => void
  onRemoveAsset: (assetId: number) => void
  postType: string
  readOnly: boolean
  updateCaption?: () => void
}

export const Stream: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content,
  display = 'mobileStream',
  gif,
  index,
  isAccountPremium,
  isPresenting,
  isThreaded,
  modulesLength,
  onContentChange,
  onExpandAsset,
  onRemoveAsset,
  postType,
  readOnly,
  updateCaption,
}) => (
  <Fragment>
    <TwitterStreamHeader
      accountImage={accountImage}
      accountName={accountName}
      accountUsername={accountUsername}
      content={content}
      isAccountPremium={isAccountPremium}
      isMobile={display.includes('mobile')}
      isThreaded={isThreaded}
      index={index}
      postType={postType}
      modulesLength={modulesLength}
      onContentChange={onContentChange}
      readOnly={readOnly}
    />
    <div
      css={assetStyles.getAssetContainerStyles(display)}
      className={kuiperClassNames('twitter-gif-asset-container')}
    >
      {gif && (
        <Fragment>
          <Asset
            imageFit="cover"
            hasAssetOverlay={Boolean(gif) && (!readOnly || isPresenting)}
            assetReference={gif}
            placeholder={true}
            removeable={!isPresenting}
            hasAssetOptions={true}
            onEmbiggen={() => onExpandAsset(gif.id || 0)}
            onRemove={() => onRemoveAsset(gif.id || 0)}
            overrideStyles={assetStyles.getAssetStyles(gif, display)}
            updateCaption={updateCaption}
          />
          <div css={assetStyles.gifLabelStyles}>GIF</div>
        </Fragment>
      )}
    </div>
    <TwitterStreamFooter isMobile={display.includes('mobile')} />
  </Fragment>
)
